import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_STORAGE_KEYS, AuthStore } from '@aurrica-web/core-data';

/** Used by route guards to detect a browser session before Cognito user attrs are re-hydrated. */
export function hasStoredSession(): boolean {
  const refreshToken = localStorage.getItem(AUTH_STORAGE_KEYS.refreshToken);
  const idToken = localStorage.getItem(AUTH_STORAGE_KEYS.idToken);
  return Boolean(refreshToken || idToken);
}

export const authGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  if (authStore.isAuthenticated() || hasStoredSession()) {
    return true;
  }

  const requested = state.url ?? '/';
  if (requested !== '/' && requested !== '/login') {
    localStorage.setItem(AUTH_STORAGE_KEYS.requestedUrl, requested);
    return router.createUrlTree(['/login'], {
      queryParams: { redirectUrl: requested },
    });
  }

  return router.parseUrl('/login');
};

/** Prevent authenticated users from manually visiting the login page. */
export const loginRedirectGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const hasSession = hasStoredSession();
  // Stale store flag after logout must not bounce the user back into booking.
  if (hasSession && authStore.isAuthenticated()) {
    return router.parseUrl('/dashboard');
  }
  return true;
};
